// extracted by mini-css-extract-plugin
export default {"testimonials":"Testimonials_testimonials__FCsqR","title":"Testimonials_title__b6u4P"};